module.exports = __webpack_public_path__ + "static/img/Joe-Chan.6c86a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joe-Chan.jpg
// module id = LsW9
// module chunks = 0